var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('b-col',[_c('hr')]),_c('b-button',{staticClass:"float-right",attrs:{"variant":"outline-primary","size":"sm"},on:{"click":function($event){return _vm.$emit('closeModal')}}},[_vm._v(" INCHIDE ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }